import { useMemo } from 'react';
import { CardEnum } from '@colonist/game-states';
import { usePlayerValidators } from '../../../store/selectors/usePlayerValidators.ts';
import { useMechanicValidatorDevelopmentCard } from '../../../store/selectors/useMechanicValidatorDevelopmentCard.ts';
import { useMechanicValidatorProgressCards } from '../../../store/selectors/useMechanicValidatorProgressCards.ts';
import { useMechanicValidatorLargestArmy } from '../../../store/selectors/useMechanicValidatorLargestArmy.ts';
import { useMechanicValidatorKnight } from '../../../store/selectors/useMechanicValidatorKnight.ts';
import { useMechanicValidatorLongestRoad } from '../../../store/selectors/useMechanicValidatorLongestRoad.ts';
export const usePlayerInfoSectionContentHandProps = (playerColor)=>{
    var _longestRoadValidator_getLongestRoadPlayerState;
    const { getPlayerValidator } = usePlayerValidators();
    const playerValidator = getPlayerValidator(playerColor);
    const resourceCardCount = playerValidator.resourceCards.getNumberOfCardsInInventory();
    const isResourceCardCountOverLimit = resourceCardCount > playerValidator.cardDiscardLimit;
    const developmentCardsValidator = useMechanicValidatorDevelopmentCard();
    const developmentCardCount = developmentCardsValidator === null || developmentCardsValidator === void 0 ? void 0 : developmentCardsValidator.getPlayersTotalDevelopmentCards(playerColor);
    const progressCardsValidator = useMechanicValidatorProgressCards();
    const progressCardCount = progressCardsValidator === null || progressCardsValidator === void 0 ? void 0 : progressCardsValidator.getPlayersTotalProgressCards(playerColor);
    const largestArmyValidator = useMechanicValidatorLargestArmy();
    const largestArmyCount = developmentCardsValidator === null || developmentCardsValidator === void 0 ? void 0 : developmentCardsValidator.getPlayersTotalUsedDevelopmentCardsOfType(playerColor, CardEnum.Knight);
    const hasLargestArmy = (largestArmyValidator === null || largestArmyValidator === void 0 ? void 0 : largestArmyValidator.getPlayerWithLargestArmy()) === playerColor;
    const knightValidator = useMechanicValidatorKnight();
    const knightCount = knightValidator === null || knightValidator === void 0 ? void 0 : knightValidator.getKnightPlayerValidator(playerColor).getPlayerKnightStrength();
    const hasHighestKnightStrength = knightValidator === null || knightValidator === void 0 ? void 0 : knightValidator.getPlayersWithHighestKnightStrength().includes(playerColor);
    const longestRoadValidator = useMechanicValidatorLongestRoad();
    const longestRoadCount = longestRoadValidator === null || longestRoadValidator === void 0 ? void 0 : (_longestRoadValidator_getLongestRoadPlayerState = longestRoadValidator.getLongestRoadPlayerState(playerColor)) === null || _longestRoadValidator_getLongestRoadPlayerState === void 0 ? void 0 : _longestRoadValidator_getLongestRoadPlayerState.longestRoad;
    const hasLongestRoad = (longestRoadValidator === null || longestRoadValidator === void 0 ? void 0 : longestRoadValidator.getPlayerWithLongestRoadCard()) === playerColor;
    return useMemo(()=>({
            resourceCardCount: resourceCardCount,
            resourceCardDiscardLimit: playerValidator.cardDiscardLimit,
            developmentCardCount: developmentCardCount,
            progressCardCount: progressCardCount,
            largestArmyCount: largestArmyCount,
            highlightLargestArmy: hasLargestArmy,
            defenderOfColonistCount: knightCount,
            highlightDefenderOfColonist: hasHighestKnightStrength && (knightCount !== null && knightCount !== void 0 ? knightCount : 0) > 0,
            longestRoadCount: longestRoadCount,
            highlightLongestRoad: hasLongestRoad
        }), [
        resourceCardCount,
        isResourceCardCountOverLimit,
        developmentCardCount,
        progressCardCount,
        largestArmyCount,
        hasLargestArmy,
        knightCount,
        hasHighestKnightStrength,
        longestRoadCount,
        hasLongestRoad
    ]);
};
